import pRetry from "p-retry";

export async function getEmployees({ contract_number }) {
    return await pRetry(async () => {
        return await _getEmployees({ contract_number });
    }, { retries: 5 });
}

export async function _getEmployees({ contract_number }) {
    const response = await window.fetch(
        `${process.env.REACT_APP_API_URL}/api/employee/get_employees`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ contract_number }),
        }
    );

    const data = await response.json();
    const result = data?.result;

    if (!Array.isArray(result)) {
        return [];
    }
    return result;
}

export async function deleteEmployee({ contract_number, tg_id, max_id }) {
    return await pRetry(async () => {
        return await _deleteEmployee({ contract_number, tg_id, max_id });
    }, { retries: 5 });
}

export async function _deleteEmployee({ contract_number, tg_id, max_id }) {
    const body = { contract_number };
    if (tg_id) {
        body.tg_id = tg_id.toString();
    } else if (max_id) {
        body.max_id = max_id.toString();
    }

    const response = await window.fetch(
        `${process.env.REACT_APP_API_URL}/api/employee/delete_employee`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        }
    );

    if (!response.ok) {
        const text = await response.text();
        let message = text;
        try {
            const json = JSON.parse(text);
            message = json?.detail ?? json?.message ?? text;
        } catch (_) {}
        throw new Error(message || `delete_employee: ${response.status}`);
    }

    return response.json().catch(() => ({}));
}

export async function inviteEmployee({ contract_number }) {
    return await pRetry(async () => {
        return await _inviteEmployee({ contract_number });
    }, { retries: 5 });
}

export async function _inviteEmployee({ contract_number }) {
    const response = await window.fetch(
        `${process.env.REACT_APP_API_URL}/api/employee/invite_employee`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ contract_number }),
        }
    );

    const data = await response.json();

    if (!response.ok) {
        const message =
            data?.detail ?? data?.message ?? `invite_employee: ${response.status}`;
        throw new Error(message);
    }

    return { token: data?.token ?? "" };
}
